import { render, staticRenderFns } from "./Trendingtopicnew copy.vue?vue&type=template&id=6c5ce722"
import script from "./Trendingtopicnew copy.vue?vue&type=script&lang=js"
export * from "./Trendingtopicnew copy.vue?vue&type=script&lang=js"
import style0 from "./Trendingtopicnew copy.vue?vue&type=style&index=0&id=6c5ce722&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports